<template>
  <div class="job-list">
    <data-table :service="LogService"
                :entity="entity"
                :columns="columns"
                :filters="logFilters"
                :go-to-details-on-row-click="false"
                ref="table">
      <template v-slot:type="{row}">
        <component :is="typeMappings[row.type]"></component>
      </template>
      <template v-slot:level="{row}">
        <status-badge :status="row.level"></status-badge>
      </template>
      <template v-slot:created_at="{row}">
        {{$formatDate(row.created_at, FRIENDLY_DATE_FORMAT)}}
      </template>
    </data-table>
  </div>
</template>
<script>
  import LogService from 'src/services/LogService'
  import entities from 'src/config/entities'
  import { FRIENDLY_DATE_FORMAT } from 'src/config/dateUtils'
  import {
    DatabaseIcon,
    FileTextIcon,
    RepeatIcon,
    TrashIcon
  } from 'vue-feather-icons'

  export default {
    name: 'log-list',
    components: {
      DatabaseIcon,
      RepeatIcon,
      TrashIcon,
      FileTextIcon
    },
    props: {
      filters: {
        type: Array,
        default: () => []
      },
    },
    data () {
      return {
        LogService,
        entity: entities.LOG,
        FRIENDLY_DATE_FORMAT,
        typeMappings: {
          store: 'DatabaseIcon',
          change: 'RepeatIcon',
          delete: 'TrashIcon',
          log: 'FileTextIcon',
        },
      }
    },
    computed: {
      columns () {
        return [
          {
            prop: 'type',
            label: this.$t('logs.list.columns.type'),
            minWidth: '35px',
            sortable: true
          },
          {
            prop: 'description_translated',
            label: this.$t('logs.list.columns.description'),
            minWidth: '240px',
            sortable: true
          },
          {
            prop: 'user_agent',
            label: this.$t('logs.list.columns.user_agent'),
            minWidth: '250px',
            sortable: true
          },
          {
            prop: 'level',
            label: this.$t('logs.list.columns.level'),
            minWidth: '60px',
            sortable: true
          },
          {
            prop: 'created_at',
            label: this.$t('generic.createdAt'),
            minWidth: '180px',
            sortable: true
          }
        ]
      },
      logFilters () {
        return [
          { key: 'with', value: 'products' },
          ...this.filters
        ]
      }
    }
  }
</script>
<style>
</style>
